import { Box, ColorOptions, Image, ModBox, Spacer, useWindowDimensions } from '@jfs/ui-new'
import { useState } from 'react'
import { Dimensions } from 'react-native'
import { BoxLayout } from '../../comps/BoxLayout'
import ContactUs from '../../comps/ContactUs'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import Navbar from '../../comps/Nav'
import NavMob from '../../comps/NavMobile'
import { posBoxesData } from '../../static/staticData'
import { colors } from '../../util/colors'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth } from '../../util/util'
import { JioBizzSection } from './JioBizzSection'
import { JiopayOneQr } from './JiopayOneQr'
import { ModernSmartDevice } from './ModernSmartDevice'
import { PosSection } from './PosSection'

const ImageLanding = require('../../assets/svg/pos-device.svg')
const ImageLandingTab = require('../../assets/images/home-screen/jio-marketing-banner-tab.png')

const Pos = () => {
  const resPadding = usePadding()
  const viewPortWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewPortWidth)

  const [navVisible, setNavVisible] = useState(false)
  const handleNav = (): void => {
    document.body.style.overflow = 'hidden' // body scroll disabled
    setNavVisible((prev) => !prev)
  }

  const setVisiblity = (): void => {
    document.body.style.overflow = 'scroll' // body scroll disabled
    setNavVisible(false)
  }

  const nav = (
    <Box>
      <NavMob onPress={setVisiblity} />
    </Box>
  )

  const isTab = isTabletWidth(viewPortWidth)

  const returnImageStyle = () => {
    if (isMob) {
      return { ...imageStyle.portaitImageStyle }
    } else if (isTab) {
      return { ...imageStyle.portaitTabImageStyle }
    } else {
      return { ...imageStyle.wide }
    }
  }

  const returnImage = () => {
    if (isMob) {
      return ImageLanding
    } else if (isTab) {
      return ImageLandingTab
    } else {
      return ImageLanding
    }
  }

  return (
    <Box f={1}>
      <Modal view={nav} visible={navVisible} onPress={setVisiblity} type={ModalTypes.NAVBAR_RIGHT} />
      <Navbar isBg={true} onPress={handleNav} hamBurgerType="primary" isLightBackground={false} />
      <ModBox
        show={!isMob}
        zIndex={-9999}
        bg={colors.JIO_PRIMARY_ALPHA as ColorOptions}
        alignItems={'flex-end'}
        overflow={'visible'}
        h={'calc(100vh - 72px)'}>
        <Box mr={resPadding} mt={90}>
          <Image resizeMode="contain" source={returnImage()} {...returnImageStyle()} />
        </Box>
      </ModBox>
      <Box
        zIndex={1}
        position={isMob ? 'relative' : 'absolute'}
        h={'calc(100vh - 72px)'}
        overflow={'scroll'}
        top={isMob ? undefined : 72}
        bg={isMob ? (colors.JIO_PRIMARY_ALPHA as ColorOptions) : 'TRANSPARENT'}>
        <Spacer size={isMob ? 0 : 32} direction={'vertical'} />
        <PosSection />
        <Box ph={resPadding}>
          <BoxLayout data={posBoxesData} />
        </Box>
        <Spacer size={isMob ? 32 : 132} direction={'vertical'} />
        <Box
          borderTopLeftRadius={isMob ? 32 : 120}
          borderTopRightRadius={isMob ? 32 : 120}
          bg={'WHITE'}
          ph={resPadding}
          pv={isMob ? 32 : 120}
          zIndex={1}>
          <ModernSmartDevice />
          <JiopayOneQr />
          <JioBizzSection />
        </Box>
        <Box marginTop={isMob ? -32 : -120} zIndex={10}>
          <ContactUs type={'footer'} />
        </Box>
      </Box>
    </Box>
  )
}

const width = Dimensions.get('window').width

const imageStyle = {
  portaitImageStyle: {
    height: '100%',
    width: width,
  },
  wide: {
    width: 541,
    height: 537,
    top: 0,
    left: 0,
  },
  portaitTabImageStyle: {
    width: 496,
    height: 600,
  },
}

export default Pos
